

const WIDTH = 992
export default {
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  mounted() {
    const isMobile = this.$_isMobile()
    // 做相应的逻辑处理，控制哪些显示哪些不显示？怎么显示？等
  },
  methods: {
    $_isMobile() {
      const rect = document.body.getBoundingClientRect()
      return rect.width - 1 < WIDTH
    },
    $_resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.$_isMobile()
        this.$store.commit("changeDevice", isMobile ? 'mobile' : 'desktop');
        // this.$store.dispatch('app/toggleDevice', isMobile ? 'mobile' : 'desktop')
        // 做相应的逻辑处理，控制哪些显示哪些不显示？怎么显示？等
      }
    }
  }
}
